<template>
  <base-open-savings-deposit-modal
    :isVisible="isVisible"
    :showIcon="true"
    :title="translations.modalTitle"
    :text="translations.modalText"
    :onCancelLabel="translations.skip"
    :onSubmitLabel="translations.createDeposit"
    :onCancelFn="onCancel"
    :onSubmitFn="onSubmit"
  />
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { isNil } from 'lodash'
import { useRootStore } from '@/store/root'
import { useAccountStore } from '@account/store/accountStore'
import { DepositType, DepositRouteName } from '@deposits/const'
import { AccountRouteName } from '@account/const'
import BaseOpenSavingsDepositModal from '@/components/savings-deposit/BaseOpenSavingsDepositModal.vue'
import api from '@/api'

export default {
  name: 'savings-deposit-upsell-modal',
  components: {
    BaseOpenSavingsDepositModal
  },
  computed: {
    ...mapState(useRootStore, [
      'myDepositsMenuItemIsDisabled',
      'isApplyForNewDemandDepositDisabled',
      'confirmAccountDataForTransactions'
    ]),
    ...mapState(useAccountStore, [
      'hasSeenMandatorySavingsDepositModalCount',
      'hasSeenMandatorySavingsDepositModalCountLoaded'
    ]),
    translations () {
      return {
        modalTitle: this.$pgettext('savings_deposit_upsell_modal', 'Create your first saving deposit'),
        modalText: this.$pgettext('savings_deposit_upsell_modal', 'In order to open a savings account, we recommend signing a savings deposit agreement. Daily interest is calculated on the balance of the savings account, there is no obligation to transfer money to the savings account and there are no costs involved'),
        skip: this.$pgettext('savings_deposit_upsell_modal', 'Skip'),
        createDeposit: this.$pgettext('savings_deposit_upsell_modal', 'Create deposit')
      }
    },
    applyingForDemandDepositIsEnabled () {
      return !this.myDepositsMenuItemIsDisabled &&
        !this.isApplyForNewDemandDepositDisabled
    },
    isVisible () {
      return this.applyingForDemandDepositIsEnabled &&
        this.hasSeenMandatorySavingsDepositModalCount === 0 &&
        !isNil(this.$route.name) &&
        (!this.confirmAccountDataForTransactions || this.$route.name !== AccountRouteName.ConfirmData) &&
        this.$route.name !== DepositRouteName.New
    }
  },
  methods: {
    ...mapActions(useRootStore, [
      'getDepositsCount'
    ]),
    ...mapActions(useAccountStore, [
      'getHasSeenMandatorySavingsDepositModalCount',
      'increaseHasSeenMandatorySavingsDepositModalCount'
    ]),
    async onCancel () {
      await api.increaseHasSeenMandatoryOpenSavingsDepositModal()
      this.increaseHasSeenMandatorySavingsDepositModalCount()
    },
    async onSubmit () {
      await this.onCancel()
      this.$router.push({ name: DepositRouteName.New, params: { depositType: DepositType.Demand } })
    }
  },
  watch: {
    applyingForDemandDepositIsEnabled: {
      immediate: true,
      async handler (isEnabled) {
        if (isEnabled && !this.hasSeenMandatorySavingsDepositModalCountLoaded) {
          await this.getHasSeenMandatorySavingsDepositModalCount()
        }
      }
    }
  },
  async mounted () {
    await this.getDepositsCount()
  }
}
</script>
